/**
 * Splits a file path into its base name and extension.
 * The extension is returned without the leading dot, lower-cased.
 * Returns an empty extension when the name has no dot.
 *
 * @param path - file path or bare file name
 * @returns `{ name, ext }` — `name` keeps original casing, `ext` is lower-cased
 *
 * @example
 * getFileNameAndExt('docs/report.PDF')   // { name: 'report.PDF', ext: 'pdf' }
 * getFileNameAndExt('archive.tar.gz')    // { name: 'archive.tar.gz', ext: 'gz' }
 * getFileNameAndExt('README')            // { name: 'README', ext: '' }
 */
export function getFileNameAndExt(path: string): { name: string; ext: string } {
  const name = path.split('/').pop() ?? path;
  const dotIndex = name.lastIndexOf('.');
  const ext = dotIndex > 0 ? name.slice(dotIndex + 1).toLowerCase() : '';
  return { name, ext };
}
